import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Route, Routes, RouterProvider, Switch} from 'react-router'
import {
    createRoutesFromElements,
    createBrowserRouter,
    // Route,
    // Routes,
    // RouterProvider,
    HistoryRouter,
    useParams,
    useMatch,
    useLocation,
    useNavigate
    // useRoutes
} from "react-router-dom";
import {BrowserRouter} from "react-router-dom";
// import {RouteObject, useRoutes} from "react-router-dom";

import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux'

import Layout from './Layout';
import RouterLayout from './RouterLayout';
import Home from './Containers/Home';
import NotFound from './Containers/NotFound';
import Sell from './Containers/Sell';
import Search from './Containers/Search';
import Product from './Containers/Product';
import SearchInput from './Containers/SearchInput';
import Login from './Containers/Login';
import SearchCategory from './Containers/SearchCategory';
import SearchProducts from './Containers/SearchProducts';
import ManageProducts from './Containers/ManageProducts';
import UpdateSellProduct from './Containers/UpdateSellProduct';
import EditProduct from './Containers/EditProduct';
import Orders from './Containers/Orders';
import Upload from './Containers/Upload';
import UploadListing from './Containers/UploadListing';
import SearchByCategory from './Containers/SearchByCategory';
import SearchCategoryProducts from './Containers/SearchCategoryProducts';
//
import BankAccount from "./Containers/Financial/BankAccount";
import AccountSummary from "./Containers/Financial/AccountSummary";
import Transactions from "./Containers/Financial/Transactions";
import InvoiceListing from "./Containers/Invoice/InvoiceListing";
import InvoiceCreate from "./Containers/Invoice/InvoiceCreate";
import {check} from './actions/authActions';
import './styles/index.css'


import {configureStore, history} from './store';
import axios from "axios";


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

let store = configureStore();

store.dispatch(check(false));

const root = ReactDOM.createRoot(document.getElementById('root'));


const MyAppParams = function () {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch(window.location.pathname);
    match.params = params;
    match.path = match.pathname;
    return {
        params: params,
        match: match,
        location: location,
        history: history,
        navigateTo: navigate,
    }
}

const RouterComponent = function ({Component, props}) {
    const params = MyAppParams();
    if(props && typeof props.useLayout === 'boolean' && !props.useLayout){
        return <Component {...params} />;
    }
    return <RouterLayout {...params} component={Component}/>;
}


root.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routes>
                {/*<Route path="/:businessSlug/search" children={(matchProps) => (*/}
                {/*    <Layout {...matchProps}>*/}
                {/*        <Search>*/}
                {/*            <Route path="/:businessSlug/search" element={<RouterComponent Component={SearchInput} />}/>*/}
                {/*            <Route path="/:businessSlug/search/k/:keyword" element={<RouterComponent Component={SearchCategory} />}/>*/}
                {/*            <Route path="/:businessSlug/search/k/:keyword/:categoryId" element={<RouterComponent Component={SearchProducts} />}/>*/}
                {/*            <Route exact path="/:businessSlug/search/categories" element={<RouterComponent Component={SearchByCategory} />}/>*/}
                {/*            <Route exact path="/:businessSlug/search/categories/:categoryId" element={<RouterComponent Component={SearchByCategory} />}/>*/}
                {/*            <Route exact path="/:businessSlug/search/categories/:categoryId/products"*/}
                {/*                   element={<RouterComponent Component={SearchCategoryProducts} />}/>*/}
                {/*            <Route exact path="/:businessSlug/search/categories/:categoryId/products/:keyword"*/}
                {/*                   element={<RouterComponent Component={SearchCategoryProducts} />}/>*/}
                {/*        </Search>*/}
                {/*    </Layout>*/}
                {/*)}/>*/}
                <Route path="/:businessSlug/search">
                    <Route index={true} path="/:businessSlug/search" element={<RouterComponent Component={SearchInput}/>}/>
                    <Route path="/:businessSlug/search/k/:keyword"
                           element={<RouterComponent Component={SearchCategory}/>}/>
                    <Route path="/:businessSlug/search/k/:keyword/:categoryId"
                           element={<RouterComponent Component={SearchProducts}/>}/>
                    <Route exact path="/:businessSlug/search/categories"
                           element={<RouterComponent Component={SearchByCategory}/>}/>
                    <Route exact path="/:businessSlug/search/categories/:categoryId"
                           element={<RouterComponent Component={SearchByCategory}/>}/>
                    <Route exact path="/:businessSlug/search/categories/:categoryId/products"
                           element={<RouterComponent Component={SearchCategoryProducts}/>}/>
                    <Route exact path="/:businessSlug/search/categories/:categoryId/products/:keyword"
                           element={<RouterComponent Component={SearchCategoryProducts}/>}/>
                </Route>

                <Route exact path="/login" element={<RouterComponent Component={Login}/>}/>
                <Route exact path="/404" element={<RouterComponent Component={NotFound} props={{useLayout:false}}/>}/>

                <Route exact path="/" element={<RouterComponent Component={Home}/>}/>
                <Route exact path="/:businessSlug" element={<RouterComponent Component={Home}/>}/>
                <Route exact path="/:businessSlug/sell/:productId" element={<RouterComponent Component={Sell}/>}/>
                <Route exact path="/:businessSlug/create/:categoryId" element={<RouterComponent Component={Product}/>}/>
                <Route exact path="/:businessSlug/update-sell/:id"
                       element={<RouterComponent Component={UpdateSellProduct}/>}/>
                <Route exact path="/:businessSlug/update/:productHashId"
                       element={<RouterComponent Component={EditProduct}/>}/>
                <Route exact path="/:businessSlug/manage" element={<RouterComponent Component={ManageProducts}/>}/>
                <Route exact path="/:businessSlug/manage/:status"
                       element={<RouterComponent Component={ManageProducts}/>}/>
                <Route exact path="/:businessSlug/manage/:status/:keyword"
                       element={<RouterComponent Component={ManageProducts}/>}/>
                <Route exact path="/:businessSlug/orders" element={<RouterComponent Component={Orders}/>}/>
                <Route exact path="/:businessSlug/orders/:status" element={<RouterComponent Component={Orders}/>}/>
                <Route exact path="/:businessSlug/upload" element={<RouterComponent Component={Upload}/>}/>
                <Route exact path="/:businessSlug/upload/list/:id"
                       element={<RouterComponent Component={UploadListing}/>}/>
                <Route exact path="/:businessSlug/financial/account-summary"
                       element={<RouterComponent Component={AccountSummary}/>}/>
                <Route exact path="/:businessSlug/financial/transactions"
                       element={<RouterComponent Component={Transactions}/>}/>
                <Route exact path="/:businessSlug/financial/bank" element={<RouterComponent Component={BankAccount}/>}/>
                <Route exact path="/:businessSlug/invoice" element={<RouterComponent Component={InvoiceListing}/>}/>
                <Route exact path="/:businessSlug/invoice/create"
                       element={<RouterComponent Component={InvoiceCreate}/>}/>
                <Route element={<RouterComponent Component={NotFound}/>}/>
            </Routes>
        </BrowserRouter>
        {/*<ConnectedRouter history={history}>*/}
        {/*    */}
        {/*</ConnectedRouter>*/}

        {/*<Switch>*/}


        {/*</Switch>*/}
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
